import axios from "axios";

// Enable CSRF protection and credentials
axios.defaults.withCredentials = true;

let baseURL = "http://localhost:8000";

if (process.env.NODE_ENV === 'production') {
  baseURL = 'https://back.opgi-boumerdes.dz';
} 

export const api = axios.create({
    withCredentials: true,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
    baseURL: baseURL,
  });

// Add CSRF token interceptor - more robust version
api.interceptors.request.use((config) => {
  const csrfToken = getCsrfToken();
  if (csrfToken) {
    // Always set both header variants
    config.headers['X-CSRF-TOKEN'] = csrfToken;
    config.headers['X-CSRF-Token'] = csrfToken;
    
    // Log for debugging (only for non-blob requests)
    if (config.url.includes('derogations') && config.responseType !== 'blob') {
      const contentType = config.data instanceof FormData ? 'multipart/form-data' : typeof config.data;
      console.log('[CSRF] Request to', config.url, '- Data type:', contentType, '- Token length:', csrfToken.length);
    }
  } else {
    // Log that token is missing but allow request to proceed
    // (for public endpoints or endpoints that will initialize CSRF first)
    if (!config.url.includes('csrf-token') && !config.url.includes('login') && !config.url.includes('register')) {
      console.warn('[CSRF] Token not available for request to', config.url);
    }
  }
  
  // Ensure FormData is never serialized
  if (config.data instanceof FormData) {
    // Don't set Content-Type - let the browser/axios handle it with boundary
    delete config.headers['Content-Type'];
  } else if (config.data && typeof config.data === 'object' && !Array.isArray(config.data)) {
    // Set JSON content type only for plain objects (not for GET/blob requests)
    if (!config.headers['Content-Type'] && config.method !== 'get') {
      config.headers['Content-Type'] = 'application/json';
    }
  }
  
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Helper function to get CSRF token from cookie
function getCsrfToken() {
  const name = 'XSRF-TOKEN';
  
  if (!document.cookie || document.cookie === '') {
    console.warn('[CSRF] No cookies found');
    return null;
  }
  
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    const eqIndex = cookie.indexOf('=');
    
    if (eqIndex > -1) {
      const cookieName = cookie.substring(0, eqIndex);
      if (cookieName === name) {
        const token = decodeURIComponent(cookie.substring(eqIndex + 1));
        console.log('[CSRF] Token found and extracted');
        return token;
      }
    }
  }
  
  console.warn('[CSRF] XSRF-TOKEN cookie not found in cookies:', document.cookie);
  return null;
}

export const seccussUrl = `${baseURL}/api/payement`;

// Fetch CSRF token on app initialization
export async function initializeCsrf() {
  const maxRetries = 3;
  const retryDelay = 1000; // ms
  
  for (let attempt = 0; attempt < maxRetries; attempt++) {
    try {
      const response = await api.get('/csrf-token', { 
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      // Store token in cookie for subsequent requests
      if (response.data && response.data.token) {
        document.cookie = `XSRF-TOKEN=${response.data.token}; path=/; SameSite=Strict`;
        console.log('[CSRF] Token stored in cookie successfully');
        return true;
      }
      console.log('[CSRF] Token initialization successful');
      return true;
    } catch (error) {
      console.warn(`[CSRF] Initialization attempt ${attempt + 1}/${maxRetries} failed:`, error.message);
      
      // Don't retry on 404 (endpoint doesn't exist) or if it's the last attempt
      if (error.response?.status === 404 || attempt === maxRetries - 1) {
        console.error('[CSRF] Initialization failed permanently:', error.message);
        console.warn('[CSRF] App will continue - some endpoints may fail if CSRF is required');
        return false;
      }
      
      // Wait before retrying
      await new Promise(resolve => setTimeout(resolve, retryDelay));
    }
  }
}

export const captcah_site_key = process.env.NODE_ENV === 'production' ? "6LfO68coAAAAAOf29pnOf5FSioQLt7CVgfCSOHJr" : process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

export const BASE_URL = baseURL;